import { getAmplitudePageNameFromPath } from '@/utils/getPageNameFromPath';
import { getDeployment } from '@/redux/modules/config';
import { getFullUrl } from '@/utils/amplitude/analytics/utils/getFullUrl';
import { track } from '@/utils/amplitude/analytics/core';
import { TrackingEvents } from '@/utils/amplitude/analytics/core.types';
import { useAppSelector } from '@/redux/hooks';
import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

type TrackItemCardClickedParams = {
    catalogId: number;
    itemId: number;
    promoted: boolean;
    source: ItemCardSource;
};

/**
 * Generic function to track when an item card is clicked
 * @returns A function to track the conversion
 */
export enum ItemCardSource {
    CatalogPageConsole = 'catalog_page_console',
    CoverLots = 'cover_lots',
    LotDetailsPage = 'lot_details_page',
    MyItemsPageBids = 'my_items_page_bids_tab',
    MyItemsPageBidsPast = 'my_items_page_bids_past_tab',
    MyItemsPageFavorites = 'my_items_page_favorites_tab',
    MyItemsPageFavoritesPast = 'my_items_page_favorites_past_tab',
    WonItemsPage = 'won_items_page',
}

export const useTrackItemCardClicked = () => {
    const deployment = useAppSelector(getDeployment);
    const { pathname } = useLocation();

    return useCallback(
        ({ catalogId, itemId, promoted, source }: TrackItemCardClickedParams) => {
            track(TrackingEvents.Item.ItemCardClicked, {
                catalogId,
                featured: promoted,
                itemId,
                pageName: getAmplitudePageNameFromPath(pathname),
                source,
                url: getFullUrl(deployment, pathname),
            });
        },
        [deployment, pathname]
    );
};
